export const ACTIVITY_MODEL_TYPE_CONTACT = "Contact";
export const ACTIVITY_MODEL_TYPE_ENTITY = "Entity";
export const ACTIVITY_MODEL_TYPE_CASE = "Case";
export const ACTIVITY_MODEL_TYPE_CAMPAIGN = "Campaign";
export const ACTIVITY_MODEL_TYPE_REV_OPPORTUNITY = "revenue_opportunity";

export const CONTACT_FORM_MODEL_SMS = "sms";
export const CONTACT_FORM_MODEL_WHATSAPP = "whatsapp";
export const CONTACT_FORM_MODEL_LINKEDIN = "linkedin";
export const CONTACT_FORM_MODEL_EMAIL = "email";
export const CONTACT_FORM_MODEL_CALL = "call";
